var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import './FullBleedHero.scss';
export var FullBleedHero = function (_a) {
    var data = _a.data;
    var _b = useState(0), isVideoReady = _b[0], setIsVideoReady = _b[1];
    var videoRef = useRef(null);
    useEffect(function () {
        // const timelineOps: any = {
        //   delay: 0.5,
        // };
        // if (data.withAnimation) {
        //   timelineOps.scrollTrigger = {
        //     start: 'center center',
        // scroller: `#container-snap-scroller`,
        //     trigger: '.intelligent',
        //   };
        // }
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.intelligent_overlay',
                start: 'top center',
            },
        });
        tl.fromTo('.intelligent__container--primary', {
            opacity: 1,
        }, {
            stagger: {
                amount: 0.5,
            },
            delay: 1,
            duration: 0.5,
            opacity: 0,
        });
        tl.fromTo('.intelligent__container--secondary', {
            opacity: 0,
        }, {
            duration: 0.5,
            opacity: 1,
        });
    }, []);
    useLayoutEffect(function () {
        if (videoRef.current && isVideoReady === 4 && data.videoAutoplay) {
            videoRef.current.play();
        }
        if (window.innerWidth > 768 && videoRef.current && data.videoAutoplay) {
            videoRef.current.setAttribute('autoplay', '');
        }
    }, [isVideoReady]);
    return (_jsxs("div", __assign({ className: "intelligent " + data.snapClassName + " snap-center container-snap-scroller" }, { children: [_jsx("div", { className: "intelligent_overlay" }, void 0),
            _jsxs("video", __assign({ ref: videoRef, className: "intelligent__video", playsInline: true, onLoadedData: function () {
                    return setIsVideoReady(videoRef.current ? videoRef.current.readyState : 0);
                }, autoPlay: data.videoAutoplay, muted: data.videoAutoplay, loop: data.videoLoop, poster: data.videoPoster, preload: "auto" }, { children: [_jsx("source", { src: data.videoBackground, type: "video/mp4" }, void 0),
                    _jsx("source", { src: data.videoBackground, type: "video/webm" }, void 0), data.unsupportedVideoMessage] }), void 0),
            _jsx("div", __assign({ className: "intelligent__container intelligent__container--primary" }, { children: _jsx("p", __assign({ className: "intelligent__copy" }, { children: data.primaryCopy }), void 0) }), void 0),
            _jsxs("div", __assign({ className: "intelligent__container intelligent__container--secondary" }, { children: [_jsxs("p", __assign({ className: "intelligent__copy" }, { children: [data.secondaryCopy1, _jsx("strong", { children: data.secondaryCopy2 }, void 0)] }), void 0),
                    _jsx("a", __assign({ className: "intelligent__button intelligent__button--animate", href: data.ctaLink }, { children: _jsx("span", { children: data.ctaCopy }, void 0) }), void 0)] }), void 0)] }), void 0));
};
